// ANX-119 — короткая однострочная выжимка тела сообщения для превью-цитаты
// (reply). Сворачивает пробелы/переносы и обрезает по длине с многоточием.
export function messageExcerpt(body: string, max = 120): string {
  const oneLine = body.replace(/\s+/g, ' ').trim();
  if (oneLine.length <= max) return oneLine;
  return oneLine.slice(0, max - 1) + '…';
}
